import { HOTELS_ROUTES } from "@b2bportal/core-utilities";

/** Time between polling requests (ms) for self-serve cancel quote/fulfillment. */
export const SELF_SERVE_CANCEL_POLL_INTERVAL_MS = 2000;

/**
 * Hardcoded `cancelReasonCode` for activities cancel fulfill (`cancelFulfillSchedule`) until the product exposes reason selection.
 */
export const ACTIVITIES_CANCEL_FULFILL_REASON_CODE =
  "Customer_Service.I_canceled_my_entire_trip";

export const HOPPER_TERMS_LINK = "";
export const FAQ_LINK = "";
export const PRIVACY_POLICY_LINK = "https://hopper.com/legal/privacy-policy";
export const CANADA_PHONE_COUNTRY_CODE = "+1";
export const CANADA_COUNTRY_CODE = "CA";
export const CANADA_DATE_FORMAT = "DD/MM/YYYY";

// Channel identifier issued to RBC by HTS Media (the BFF stamps the same value).
export const HTS_MEDIA_CHANNEL_ID = "rbc-web";
export const HTS_MEDIA_HOTEL_SEARCH_PLACEMENT_ID = "HotelSearchPage";

export const WALLET_PATH = "/wallet";

/**
 * Name validation regex for activities bookings.
 * Only allows:
 * - Latin letters (A-Z, a-z)
 * - Spaces
 * - Hyphens (-)
 * - Apostrophes (')
 *
 * Viator (the activities supplier) does not accept accented characters, numbers,
 * or special symbols in traveler names. This regex enforces that restriction to
 * prevent booking failures. Names must use only basic Latin characters to match
 * travel documents and satisfy supplier requirements.
 */
export const ACTIVITIES_NAME_REGEX = /^[a-zA-Z '-]+$/;

export const HOTELS_PATH = "/stays";

export const HOTELS_SEARCH_CALENDAR_HASH = "#calendar";

export const HOTELS_AVAILABILITY_PARAMS = ":location/:placeId?";

export const HOTELS_SEARCH_PATH = `${HOTELS_PATH}/${HOTELS_ROUTES.SEARCH_ROUTE}`;

export const HOTELS_AVAILABILITY_PATH = `${HOTELS_PATH}/${HOTELS_ROUTES.AVAILABILITY_ROUTE}`;

export const HOTELS_SHOP_PATH = `${HOTELS_PATH}/${HOTELS_ROUTES.SHOP_ROUTE}`;
export const HOTELS_SHOP_ROOM_PATH = `${HOTELS_SHOP_PATH}/${HOTELS_ROUTES.ROOM_SELECTION_ROUTE}`;

export const HOTELS_BOOK_PATH = `${HOTELS_PATH}/${HOTELS_ROUTES.BOOK_ROUTE}`;

export const HOTELS_ERROR_PATH = HOTELS_PATH;
export const HOMES_PATH = "/vacation-rentals";
export const HOMES_SHOP_PATH = `${HOMES_PATH}/${HOTELS_ROUTES.SHOP_ROUTE}`;

export const WATCHES_PATH = "/watches";

export const TRAVEL_OFFERS_PATH = "/travel-offers";

/**
 * Appended to the current path while the bonus earn offer dialog is open so the
 * dialog can be deep linked to (e.g. from marketing emails: `/#offer`).
 */
export const BONUS_EARN_OFFER_HASH = "#offer";
export const HOTEL_FUNDED_OFFERS_PATH = `${TRAVEL_OFFERS_PATH}/hotels`;
export const TRAVEL_DEALS_PATH = `${TRAVEL_OFFERS_PATH}/deals`;

export const DISRUPTION_EXERCISE_RELATIVE = "disruption/exercise";
export const DISRUPTION_EXERCISE_PATH = `/trips/${DISRUPTION_EXERCISE_RELATIVE}`;

export const DISRUPTION_EXERCISE_PATH_WITH_ITINERARY_ID = (
  itineraryId: string
) => `${DISRUPTION_EXERCISE_PATH}/${itineraryId}`;

/**
 * Paths where the ChatFab should be hidden (using wildcard patterns).
 * ChatFab will show on homepage variants (e.g., /flights, /stays) but hide on sub-routes (e.g., /flights/search).
 *
 * These are matched with react-router v6's `matchPath` (via react-router-dom-v5-compat) using
 * `end: false`. A single named segment is what expresses "sub-routes only": v5's `:path+` never
 * matches under v6, and `/*` would also match the bare landing path and hide the FAB there.
 *
 * NOTE: String literals are used instead of importing path constants (e.g., FLIGHTS_PATH, CARS_PATH)
 * to avoid circular dependencies. Importing from @b2bportal/core-utilities or @b2bportal/core-cars
 * here creates a circular reference since RBC's store imports from both utilities and those core packages.
 */
export const CHAT_FAB_HIDE_PATHS = [
  "/flights/:subRoute",
  HOTELS_AVAILABILITY_PATH,
  `${HOTELS_PATH}/:subRoute`,
  `${HOMES_PATH}/:subRoute`,
  "/cars/:subRoute",
  "/packages/:subRoute",
  "/activities/:subRoute",
  "/wallet/*",
];

/**
 * Chromeless standalone HTS Assist chat route. Rendered without portal chrome
 * and launched directly by the Avion mobile webview. Auth-gated (ProtectedRoute):
 * the webview must carry a valid RBC session or the user is redirected to sign-in.
 */
export const HTS_ASSIST_CHAT_PATH = "/hts-assist/chat";
